import React, { Component } from "react";
import PropTypes from 'prop-types';
import { TimeFrame, ClearTimeMob, TimeFramed } from "../styles";
import { DisplayFlexOkay, PrimaryButtonOkay,QASectionWrapper } from '../../../../TransactionSummary/Components/DateTimepicker/styles';
import { PickTimeFrame, CustomModal, CalenderClear } from '../styles';
import DateSelectorComponent from './DateTimepicker/DateSelector';
import moment from "moment";
import { connect } from 'react-redux';
import { updateFilterData, replaceWithWholeData } from "../actions";
import { recordError, oneYearBackDate, todayDate as currentDate } from "../../../../../utils/commonUtil";
import { timeFrameComponentState } from "../selectors";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

let displayDatesInitial = [oneYearBackDate(),currentDate()];
let isFilterClicked = false;
let tempDisplayDate = [oneYearBackDate(),currentDate()]
export class TimeFrameComponent extends Component {
  constructor(props) {
    super(props);
    let cDate = moment();
    let bDate = moment().subtract(30, 'd');
    let todayDate = moment(cDate).format('MM/DD/YYYY');
    let beforeMonth = moment(bDate).format('MM/DD/YYYY');
    this.state = {
      visible: false,
      dates: [beforeMonth, todayDate],
      displayDates: [oneYearBackDate(),currentDate()]
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
  }

  componentWillReceiveProps =(nextProps) => {
    if(nextProps.loadMore !== this.props.loadMore){
        if(displayDatesInitial[0]===tempDisplayDate[0] && displayDatesInitial[1]===tempDisplayDate[1])
            this.setState({displayDates:[]})
    }
  }
  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = e => {
    this.setState({
      visible: false
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false
    });

  };

  toTimeFrame = (dates) => {
    if (!dates) {
      this.setState({ dates: [] });
    }
    else {
      this.setState({ dates: dates.dateString });
    }
  }

  clearDates = () => {
    try {
      this.props.replaceWithWholeData(this.props.contributionWholeData)
      let data = null;
      let filteredData = [];
      let updatedData = this.props.contributionWholeData;
      let isCalculated = false;
        if(this.props.statusFilterData && this.props.statusFilterData.status){
          let statuses = this.props.statusFilterData.status;
          statuses.map(status => {
            let filterData = [];
            filterData.push(
              updatedData.filter(data => {
                if (data.status === status) {
                  return true;
                }
              })
            );
            if (filterData[0].length > 0) {
              filterData[0].map(data => filteredData.push(data));
            }
          });
          data = filteredData;
          isCalculated = true;
        }else{
          data = this.props.contributionWholeData;
        }      
        this.setState({displayDates:[]})
      this.setState({ dates: []});
      this.props.updateFilterData({filteredData: data, mode:"timeFrameData", data: null, dates: null, isCalculated});
    } catch (error) {
      recordError(error);
    }
  }

  mobileStartDate = (date) => {
    let dates = this.state.dates ? this.state.dates : [];
    dates[0] = date;
    isFilterClicked = false;
    this.setState({dates})
  }

  mobileEndDate = (date) => {
    let dates = this.state.dates ? this.state.dates : [];
    dates[1] = date;
    isFilterClicked = false;
    this.setState({dates})
  }

  onFilterClick(dates){
    try {
      let mainData = this.props.contributionData;
      if(this.props.statusFilterData && this.props.statusFilterData.data){
        mainData = this.props.statusFilterData.data;
      }
      if(dates.length > 1){
        let filteredData = [];   
        if (mainData !== undefined)
        {
          let updatedData = mainData;
            const date1 = moment(dates[0],"MM/DD/YYYY");
            const date2 = moment(dates[1],"MM/DD/YYYY");
            displayDatesInitial = JSON.parse(JSON.stringify([moment(dates[0]).format('MM/DD/YYYY'),moment(dates[1]).format('MM/DD/YYYY')]));
            tempDisplayDate[0] = JSON.parse(JSON.stringify(dates[0]));
            tempDisplayDate[1] = JSON.parse(JSON.stringify(dates[1]));
            this.setState({displayDates:tempDisplayDate})
            isFilterClicked = true;
            filteredData = updatedData.filter(x => {
              if(x.enteredDate !== "--"){
                if(moment(x.enteredDate, "MM/DD/YYYY") >= date1
                 && moment(x.enteredDate, "MM/DD/YYYY") <= date2){
                  return true;
                }else{
                  return false;
                }
              }
            }
            );
            this.props.updateFilterData({filteredData, mode:"timeFrameData",data: filteredData, dates: dates, isCalculated: false });
          }
          this.setState({visible: false});
      }else{
        this.props.updateFilterData({filteredData: mainData, mode:"timeFrameData",data: null, dates: null, isCalculated: false });
        this.setState({visible: false, dates: []})
      }
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    return (
      <>
        {
          this.state.displayDates && (this.state.displayDates.length && this.state.displayDates[0] && this.state.displayDates[1] ) ? <TimeFramed
            id="dateform"
          >
           <div> <ClearTimeMob onClick={this.showModal}>{moment(this.state.displayDates[0]).format('MM/DD/YYYY')} - {moment(this.state.displayDates[1]).format('MM/DD/YYYY')}</ClearTimeMob> <CalenderClear onClick={this.clearDates} >x</CalenderClear> </div>
          </TimeFramed>
            :
            <TimeFrame
              id="dateform"
              
              onClick={this.showModal}>
              -Select-
        </TimeFrame>
        }
        <CustomModal
          width="700px"
          height="500px"
          visible={this.state.visible}
          data-test="customModal"
          onCancel={this.handleCancel}
          footer={
            <DisplayFlexOkay>
          <GeneralButton 
              text = "Filter"
              width = "150px"
              mobWidth = "100%"
              data-test="filter-btn"
              onClick={()=>{this.onFilterClick(this.state.dates)}}
            />
          </DisplayFlexOkay>
          }
        >
          <PickTimeFrame>Pick Time Frame</PickTimeFrame>
          <QASectionWrapper>
          <DateSelectorComponent
            open={this.state.visible}
            defStartDate={this.state.defStartDate}
            defEndData={this.state.defEndData}
            dateValues={this.props.dateValues}
            isFilterClicked={isFilterClicked}
            displayDates={JSON.parse(JSON.stringify([moment(this.state.displayDates[0]).format('MM/DD/YYYY'),moment(this.state.displayDates[1]).format('MM/DD/YYYY')]))}
            value={this.state.dates}
            data-test="date-selector"
            mobileEndDate={(date) => this.mobileEndDate(date)}
            mobileStartDate={(date) => this.mobileStartDate(date)}
            toTimeFrame={this.toTimeFrame}
          />
          </QASectionWrapper>
        </CustomModal>
      </>
    );
  }
}

TimeFrameComponent.propTypes = {
  contributionData: PropTypes.array,
  statusFilterData: PropTypes.array,
  timeFrameData: PropTypes.array,
  updateFilterData: PropTypes.func
}

const mapStateToProps = (state) =>({
  ...timeFrameComponentState(state.toJS())
  });
  
  export const mapDispatchToProps = (dispatch) =>({
    updateFilterData: data => dispatch(updateFilterData(data)),
    replaceWithWholeData: data => dispatch(replaceWithWholeData(data))
  });


export default connect(mapStateToProps,mapDispatchToProps)(TimeFrameComponent);
